import "./App.css";
import { AppDesktop } from "./AppDesktop";
import { AppMobile } from "./AppMobile";
import { HomeConditionalRedirect } from "@/components/home-conditional-redirect";
import { PWAUpdatePrompt } from "./components/pwa/pwa-update-prompt";
import { useDeviceFormat } from "./hooks/useDeviceFormat";
import { useAppSurfaceAnalytics } from "@/hooks/useAppSurfaceAnalytics";

export function App() {
  const { isMobile } = useDeviceFormat();
  useAppSurfaceAnalytics();

  if (isMobile) {
    return (
      <>
        <AppMobile home={<HomeConditionalRedirect />} />
        <PWAUpdatePrompt />
      </>
    );
  }

  return (
    <>
      <AppDesktop home={<HomeConditionalRedirect />} />
      <PWAUpdatePrompt />
    </>
  );
}
